import { observer } from 'mobx-react'
import React, { useState } from 'react'
import RenderOnQueries from '../RenderOnQueries'
import SessionStore from '../../State/SessionStore'
import TimesheetAppStore from './TimesheetAppStore'
import AddEntryPage from './SelectCostCentrePage'
import TimeEntryPage from './TimeEntryPage'
import SelectCostCentrePage from './SelectCostCentrePage'
import SelectProjectPage from './SelectProjectPage'
import SelectPhasePage from './SelectPhasePage'
import SelectTaskPage from './SelectTaskPage'
import LoadingSpinner from '../../Components/LoadingSpinner'
import { processTRPCData } from '../../Queries/fetchData'
import { trpc } from '../../system/trpc'

export default observer(() => {
    const Page = TimesheetAppStore.displayedPage
    return (
        <RenderOnQueries
            loading={<LoadingSpinner />}
            queryIds={[
                {
                    collection: 'mobileAppData',
                    queryFn: async () => {
                        const requestData =
                            await trpc.legacy.getMobileAppData.query()
                        return processTRPCData(requestData, `mobileAppData`)
                    },
                },
            ]}
        >
            <Page />
        </RenderOnQueries>
    )
})
